enum ActionTypes {
	request = 'MedicinalBrandsAnalytics.DataSource.request',
	receive = 'MedicinalBrandsAnalytics.DataSource.receive',
}

export default ActionTypes;
